import { render, staticRenderFns } from "./AboutTile.vue?vue&type=template&id=169a2f41&"
import script from "./AboutTile.vue?vue&type=script&lang=js&"
export * from "./AboutTile.vue?vue&type=script&lang=js&"
import style0 from "./AboutTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports